import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const SearchBatchNameResponseSchema = z.array(z.object({ id: z.string(), name: z.string() }));

export type SearchBatchNameResponse = z.infer<typeof SearchBatchNameResponseSchema>;

export const SearchReleasedBatchesByNamesResponseSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    templateType: z.string().optional(),
    archived: z.boolean().optional(),
  }),
);

export type SearchReleasedBatchesByNamesResponse = z.infer<typeof SearchReleasedBatchesByNamesResponseSchema>;

export const SearchArchivedBatchesResponseSchema = z.array(
  z.object({
    value: z.string(),
    name: z.string(),
    mrn: z.string().optional(),
    searchValue: z.string().optional(),
    templateType: z.string(),
  }),
);

export type SearchArchivedBatchesResponse = z.infer<typeof SearchArchivedBatchesResponseSchema>;

export const BulkArchiveBatchesResponseSchema = z.object({
  archived: z.array(z.string()),
  failed: z.array(z.object({ id: z.string(), reason: z.string() })),
});

export type BulkArchiveBatchesResponse = z.infer<typeof BulkArchiveBatchesResponseSchema>;

export const batchesArchiveContract = c.router({
  searchReleasedBatchesByNames: {
    method: 'GET',
    path: '/batches/search-released-batches-by-names',
    query: z.object({ names: z.string() }),
    responses: {
      200: z.object({
        data: SearchReleasedBatchesByNamesResponseSchema,
      }),
    },
  },
  searchBatchName: {
    method: 'GET',
    path: '/batches/search-batch-name',
    query: z.object({ name: z.string() }),
    responses: {
      200: z.object({
        data: SearchBatchNameResponseSchema,
      }),
    },
  },
  archiveBatch: {
    method: 'PUT',
    path: '/batches/:id/archive',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({}),
    },
  },
  unarchiveBatch: {
    method: 'PUT',
    path: '/batches/:id/un-archive',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: z.object({}),
    },
  },
  bulkArchiveBatches: {
    method: 'POST',
    path: '/batches/bulk-archive',
    body: z.object({ batchIds: z.array(z.string()).min(1) }),
    responses: {
      200: z.object({ data: BulkArchiveBatchesResponseSchema }),
    },
  },
  archiveBatches: {
    method: 'POST',
    path: '/batches/archive-batches',
    body: z.object({ date: z.string().optional() }),
    responses: {
      200: z.object({ data: z.object({ archived: z.number() }) }),
    },
  },
  searchArchivedBatches: {
    method: 'GET',
    path: '/batches/search-archived-batches',
    query: z.object({ search: z.string() }),
    responses: {
      200: z.object({ data: SearchArchivedBatchesResponseSchema }),
    },
  },
  unarchiveBatches: {
    method: 'POST',
    path: '/batches/unarchive-batches',
    body: z.object({ batches: z.array(z.string()) }),
    responses: {
      200: z.object({}),
    },
  },
});
